import { useTranslation } from 'react-i18next'
import { DataItem } from 'scrivito'

import { showUndoableActionToast } from './UndoableActionToast'
import { getDataItemTitle } from '@/utils/dataClassMap'

import './UnlinkToast.scss'

interface UnlinkToastProps {
  dataItem?: DataItem | null
  onCommit: () => Promise<unknown> | unknown
  onError?: () => void
  onUndo?: () => void
  timeoutMs?: number
}

const UnlinkToast = ({ dataItem }: Pick<UnlinkToastProps, 'dataItem'>) => {
  const { t } = useTranslation()

  const title =
    getDataItemTitle(dataItem) ?? t('components.relation.entityFallback')

  return <>{t('components.relation.unlinked', { entity: title })}</>
}

export const showUnlinkToast = ({
  dataItem,
  onCommit,
  onError,
  onUndo,
  timeoutMs = 5000,
}: UnlinkToastProps) => {
  showUndoableActionToast({
    className: 'unlink-toast',
    message: <UnlinkToast dataItem={dataItem} />,
    onCommit,
    onError,
    onUndo,
    timeoutMs,
    undoLabel: <UnlinkToastUndoLabel />,
  })
}

const UnlinkToastUndoLabel = () => {
  const { t } = useTranslation()

  return <>{t('components.relation.undo')}</>
}
